import {PixiApplication} from "./PixiApplication";

window.onload = () => {
    new PixiApplication();
};



// WEBPACK FOOTER //
// ./src/app/Main.ts